import { render, staticRenderFns } from "./BindingMFAModal.vue?vue&type=template&id=51a1c9ab&scoped=true"
import script from "./BindingMFAModal.vue?vue&type=script&lang=js"
export * from "./BindingMFAModal.vue?vue&type=script&lang=js"
import style0 from "./BindingMFAModal.vue?vue&type=style&index=0&id=51a1c9ab&lang=scss"
import style1 from "./BindingMFAModal.vue?vue&type=style&index=1&id=51a1c9ab&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51a1c9ab",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/project/moneypay-web/moneypay-merchant-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('51a1c9ab')) {
      api.createRecord('51a1c9ab', component.options)
    } else {
      api.reload('51a1c9ab', component.options)
    }
    module.hot.accept("./BindingMFAModal.vue?vue&type=template&id=51a1c9ab&scoped=true", function () {
      api.rerender('51a1c9ab', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ezpay/login/components/Modal/BindingMFAModal.vue"
export default component.exports